import { Brand } from '@shared/cards-types';

const RE_BANK_CARD_FORMAT = /.{4}/g;
const RE_DINERS_CARD_FORMAT = /^(.{4})(.{6})(.{4})$/;
const CARD_NUMBER_DEFAULT_GROUP_SIZE = 4;
const CARD_NUMBER_DEFAULT_PADDING_CHAR = '0';
const CARD_NUMBER_DEFAULT_SEPARATOR = ' ';

export function isDinersCardNumber(cardNumber: string, brand = Brand.UNKNOWN): boolean {
    return brand === Brand.DINERS || RE_DINERS_CARD_FORMAT.test(cardNumber);
}

export function formatDinersCardNumber(
    cardNumber: string,
    separator = CARD_NUMBER_DEFAULT_SEPARATOR,
): string {
    const matchedCardNumber = cardNumber.trim().match(RE_DINERS_CARD_FORMAT);
    if (!matchedCardNumber) {
        return cardNumber;
    }

    return matchedCardNumber.slice(1).join(separator);
}

function addLeftPadding(
    cardNumber: string,
    groupSize = CARD_NUMBER_DEFAULT_GROUP_SIZE,
    paddingChar = CARD_NUMBER_DEFAULT_PADDING_CHAR,
): string {
    const rest = cardNumber.length % groupSize;

    if (rest !== 0) {
        const padding = groupSize - rest;
        return `${paddingChar.repeat(padding)}${cardNumber}`;
    }

    return cardNumber;
}

function removeLeftPadding(
    paddedCardNumber: string,
    paddingChar = CARD_NUMBER_DEFAULT_PADDING_CHAR,
): string {
    return paddedCardNumber.replace(new RegExp(`^([${paddingChar}]*)(.*)$`), '$2');
}

export function formatBankCardNumber(
    cardNumber = '',
    separator = CARD_NUMBER_DEFAULT_SEPARATOR,
): string {
    if (!cardNumber) {
        return '';
    }

    const paddedCardNumber = addLeftPadding(cardNumber.trim());

    const matchedCardNumber = paddedCardNumber.match(RE_BANK_CARD_FORMAT);
    if (!matchedCardNumber) {
        return cardNumber;
    }

    return removeLeftPadding(matchedCardNumber.join(separator));
}

export function formatCreditCardNumber(cardNumber = '', brand = Brand.UNKNOWN): string {
    if (!cardNumber) {
        return '';
    }

    const trimmedCardNumber = cardNumber.trim();

    if (isDinersCardNumber(trimmedCardNumber, brand)) {
        return formatDinersCardNumber(trimmedCardNumber);
    }

    return formatBankCardNumber(trimmedCardNumber);
}
